export function downcaseFirstLetter(string: string) {
  return String(string).charAt(0).toLowerCase() + String(string).slice(1);
}
